import * as FileSystem from 'expo-file-system';
import { isWeb } from 'smoothie';

export const downloadPdf = async (
    res: { data: string },
    filename: string,
): Promise<string> => {
    return isWeb
        ? downloadPdfOnWeb(res, filename)
        : await downloadPdfOnNative(res, filename);
};

const downloadPdfOnNative = async (
    res: { data: string },
    filename: string,
): Promise<string> => {
    if (FileSystem.documentDirectory != null) {
        const fileUri = `${FileSystem.documentDirectory}${filename}`;
        await FileSystem.writeAsStringAsync(fileUri, res.data, {
            encoding: 'base64',
        });
        return fileUri;
    } else {
        throw new Error('Missing permissions to write to document directory');
    }
};

const downloadPdfOnWeb = (res: { data: string }, filename: string) => {
    const file = createFileFromBase64String(res.data);
    const fileURL = URL.createObjectURL(file);
    const fileLinkElement = createFileLinkElement(fileURL, filename);

    fileLinkElement.click();
    window.URL.revokeObjectURL(fileURL);
    fileLinkElement.remove();

    return fileURL;
};

const createFileFromBase64String = (base64String: string) => {
    // Decode the base64 string into a binary string
    const binaryString = atob(base64String);

    // Create a Uint8Array from the binary string
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    return new Blob([bytes], { type: 'application/pdf' });
};

const createFileLinkElement = (fileURL: string, filename: string) => {
    // Avoids popup blocker but pushes the file to the download section instead of loading the PDF automatically
    // https://stackoverflow.com/questions/66916831/how-does-download-in-google-drive-web-work
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = fileURL;
    a.download = filename;
    document.body.appendChild(a);
    return a;
};
